import { SourceSystem } from "./BaseSourceSystem";
import React from "react";
import greenTick from "../../images/green-tick.svg";

export class SellMyCarSourceSystem extends SourceSystem {
  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    super(redirectUri, exitUri, navigate);
    this.acceptsCommercialVehicles = false;
    this.name = "sell";
    this.photosRequired = false;
    this.errorUri = redirectUri || "/sell-my-car";
    this.stepCount = 6;
    this.showEstimatedOfferPartExchange = false;
    this.showBranchValuationContent = false;
    this.sendValuationRequestEvent = true;
    this.initialOfferContent = {
      offerLabel: "We'll offer you",
      cta: "Continue without full valuation",
      subheaderTitle: "Your valuation",
      ctaMicro:
        "Alternatively, you can email yourself this valuation or book an appointment.",
      footerCTA: "Book appointment or email offer",
      assumptionsCopy:
        "*Your offer is subject to a full appraisal and based on",
      renderImageUpload: false,
      stepNumber: 3,
      ctaPersonalised: "Continue",
      assumptionsContent: (
        <div className="ch-display--flex ch-justify-content--center">
          <div className="ch-width--12 lg:ch-width--11">
            <div className="ch-text--left ch-display--flex">
              <img className="ch-mr--2" src={greenTick} alt="grey tick" />
              <span>
                This <span className="ch-text--bold">price is a guide</span>{" "}
                based on your answers and{" "}
                <button
                  className="ch-btn ch-btn--link ch-pa--0 ch-fs--2"
                  data-gtm-track="interaction"
                  data-gtm-track-label="These assumptions from estimated"
                  onClick={() => navigate("/assumptions")}
                >
                  these assumptions
                </button>
                .
              </span>
            </div>
            <div className="ch-text--left ch-display--flex   ">
              <img className="ch-mr--2" src={greenTick} alt="grey tick" />
              <p className="ch-mt--1 ch-mb--0">
                Estimated valuations are subject to a branch appraisal.
              </p>
            </div>
            <div className="ch-text--left ch-display--flex   ">
              <img className="ch-mr--2" src={greenTick} alt="grey tick" />
              <p className="ch-mt--1 ch-mb--0">
                Your final price will be agreed in consultation with you.
              </p>
            </div>{" "}
          </div>
        </div>
      )
    };
    this.estimatedOfferCTA = "Continue";
    this.quickValuation = true;
    this.showPrivacyStatement = false;
    this.analyticSearchParam = "ABYC";
    this.analyticsJourney = "ABYC";
    this.percentageStepperValue = null;

    this.handleVehicleNotFoundError = () => {
      navigate("/manual-enquiry", {
        replace: true
      });
    };

    this.getStepperPercentageValue = (pageName) => {
      const pathname = pageName || window.location.pathname;
      const sellPages = [
        {
          pageName: "/value-my-vehicle/tell-us-about-your-car/6",
          percentage: 52
        },
        {
          pageName: "/value-my-vehicle/tell-us-about-your-car/2",

          percentage: 54
        },
        {
          pageName: "/value-my-vehicle/tell-us-about-your-car/11",

          percentage: 56
        },
        {
          pageName: "/value-my-vehicle/your-cars-condition/14",
          percentage: 58
        },
        {
          pageName: "/value-my-vehicle/your-cars-condition/15",
          percentage: 60
        },
        {
          pageName: "/value-my-vehicle/your-cars-condition/18",
          percentage: 62
        },
        {
          pageName: "/value-my-vehicle/your-cars-condition/16",
          percentage: 64
        },
        {
          pageName: "/value-my-vehicle/your-cars-condition/17",
          percentage: 66
        },
        {
          pageName: "/value-my-vehicle/estimated-offer",
          percentage: 68
        }
      ];
      const page = sellPages.find((element) => element?.pageName === pathname);
      this.percentageStepperValue = page?.percentage;
      return page?.percentage;
    };

    this.getCTAValue = (pageName: string | undefined) => {
      const pathname = pageName || window.location.pathname;
      let result = "";
      switch (pathname) {
        case "/value-my-vehicle/mileage":
          result = "Next: Your valuation";
          break;
        case "/value-my-vehicle/keys":
          result = "Next: Service history";
          break;
        case "/value-my-vehicle/service-history":
          result = "Next: Vehicle usage";
          break;
        case "/value-my-vehicle/vehicle-usage":
          result = "Next: Exterior bodywork";
          break;
        case "/value-my-vehicle/bodywork":
          result = "Next: Tyres";
          break;
        case "/value-my-vehicle/tyres":
          result = "Next: Your trims/ alloys";
          break;
        case "/value-my-vehicle/wheels":
          result = "Next: Your interior";
          break;
        case "/value-my-vehicle/interior":
          result = "Next: Mechanical and electrics";
          break;
        case "/value-my-vehicle/mechanics":
          result = "Next: Your estimated valuation";
          break;
        default:
          result = "Continue";
      }
      return result;
    };

    this.handleUnableToValueError = (vehicle: IVehicle) => {
      const multiMatches = !!vehicle?.multiMatches?.length;

      const allMultiMatchesCommercial =
        multiMatches &&
        vehicle?.multiMatches?.every(
          (multiMatch) => multiMatch.capCode.slice(-1) === "L"
        );

      if (vehicle?.isCommercialVehicle || allMultiMatchesCommercial) {
        return window.location.assign(
          `/value-my-vehicle/sell-my-car/van${`?registration=${vehicle.registration?.toUpperCase()}`}`
        );
      }

      multiMatches
        ? navigate("/vehicle-variant", { replace: true })
        : navigate("/manual-enquiry", { replace: true });
    };

    this.handleAssumptionsOnSubmit = (fullValuation: boolean) => {
      fullValuation ? navigate("/estimated-offer") : navigate("/initial-offer");
    };

    this.ineligibleVehicleError = {
      ineligibleVehicleErrorContent: {
        stepPercentage: 0,
        primaryButtonText: "Enter a different registration",
        errorMain:
          "Sorry, we're unable to get an online valuation. This vehicle might be for sale or sold recently.",
        errorHint: "Try entering a different registration to continue.",
        showAltButton: false
      },
      onClickIneligibleVehicleSecondary() {},

      onClickIneligibleVehiclePrimary() {
        navigate("https://www.arnoldclark.com/sell-my-car");
      }
    };
  }
}
